import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SespDataService {
  public acronym: string;
  public taskName: string;
  public formView: string;
  public statusCodeId
  public isAdmin: boolean;
  public appData: BehaviorSubject<any> = new BehaviorSubject(null);
  public formAppData: BehaviorSubject<any> = new BehaviorSubject(null);
  public educationListData: BehaviorSubject<any> = new BehaviorSubject(null);
  public isBatchActive: boolean;
  public isSaveOnly: Boolean;
  public isCategory1: Boolean;
  public isInRevision: Boolean;
  private storageKey2 = 'sespFormAppData';
  private applicationDraft: any = null;
  // public appData;
  constructor() {
    // ✅ Load from localStorage when service initializes
    const savedData = localStorage.getItem(this.storageKey2);
    if (savedData) {
      this.formAppData.next(JSON.parse(savedData));
    }
  }
  // public setApplicationId(id, acronym, formView?,isAdmin?,application?,taskName?, statusCodeId?) {
  //   this.applicationId = id;
  //   this.acronym = acronym;
  //   this.taskName = taskName;
  //   this.formView = formView;
	// this.statusCodeId = statusCodeId;
	// this.application = application;
	// this.isAdmin = isAdmin;
  // }

  private readonly storageKey = 'formViewFromSideMenuSESP';
  private storageKey2PBSP = 'sespFormViewType';

  public setFormViewFromSideMenu(value: boolean): void {
    console.log("Setting form view:", value);
    localStorage.setItem(this.storageKey, JSON.stringify(value));
    console.log("LocalStorage after set:", localStorage.getItem(this.storageKey));
  }
  
  public getFormViewFromSideMenu(): boolean {
    const storedValue = localStorage.getItem(this.storageKey);
    console.log("Reading from LocalStorage:", storedValue);
    return storedValue ? JSON.parse(storedValue) : false;
  }
   
  

  setApplicationData(data){
    this.appData.next(data);
  }

  getApplicationData():Observable<any> {
    return this.appData.asObservable();
  }

  // setFormAppData(data){
  //   if(data){
  //   this.formAppData.next({acronym:data.processAcronym, appId:data.applicationId, formViewType: data.viewType, statusCodeId: data.statusId})
  //   }else if(data == null){
  //     this.formAppData.next(data)
  //   }
  // }
  // getFormAppData():Observable<any>{
  //   return this.formAppData.asObservable();
  // }

  // ✅ Save to BehaviorSubject + localStorage
  setFormAppData(data: any): void {
    if (data) {
      const formattedData = {
        acronym: data.processAcronym,
        appId: data.applicationId,
        formViewType: data.viewType,
        statusCodeId: data.statusId,
      };
      this.formAppData.next(formattedData);
      localStorage.setItem(this.storageKey2, JSON.stringify(formattedData));
    } else {
      this.formAppData.next(null);
      localStorage.removeItem(this.storageKey2);
    }
  }

  // ✅ Observable for components to subscribe
  getFormAppData(): Observable<any> {
    return this.formAppData.asObservable();
  }

  public syncFormAppDataFromStorage(): void {
    const savedData = localStorage.getItem(this.storageKey2);
    if (savedData) {
      this.formAppData.next(JSON.parse(savedData));
    }
  }

  public setApplicationDraft(payload: any): void {
    this.applicationDraft = payload ? { ...payload } : null;
  }

  public getApplicationDraft(): any {
    return this.applicationDraft ? { ...this.applicationDraft } : null;
  }

  public getCurrentFormAppData(): any {
    const savedData = localStorage.getItem(this.storageKey2);
    return savedData ? JSON.parse(savedData) : null;
  }

  private normalizeStatusCode(statusCode: any): number | null {
    if (statusCode === null || statusCode === undefined || statusCode === '') {
      return null;
    }
    const parsed = Number(statusCode);
    return Number.isNaN(parsed) ? null : parsed;
  }

  public isSavedEditableStatus(statusCode: any): boolean {
    const normalized = this.normalizeStatusCode(statusCode);
    return normalized === 90011 || normalized === 90017 || normalized === 9001105;
  }

  public isEditableFormContext(formAppData?: any): boolean {
    const data = formAppData || this.getCurrentFormAppData();
    if (!data) {
      return true;
    }
    const viewType = (data.formViewType || '').toString().toLowerCase();
    if (viewType === 'view') {
      return false;
    }
    if (viewType === 'edit') {
      return true;
    }
    return this.isSavedEditableStatus(data.statusCodeId);
  }

  public resolveFormType(formAppData?: any): string | undefined {
    const data = formAppData || this.getCurrentFormAppData();
    if (!data) {
      return undefined;
    }
    const viewType = (data.formViewType || '').toString().toLowerCase();
    const statusCode = this.normalizeStatusCode(data.statusCodeId);
    if (viewType === 'view' || statusCode === 90012) {
      return 'view';
    }
    if (this.isEditableFormContext(data)) {
      return undefined;
    }
    const readOnlyStatuses = [90012, 900201, 900159, 9001106];
    if (statusCode != null && readOnlyStatuses.includes(statusCode)) {
      return 'view';
    }
    return undefined;
  }

  setEducationData(data){
    if(data)
    this.educationListData.next(data);
  }

  getEducationData():Observable<any>{
    return this.educationListData.asObservable();
  }


  
}
